<template>
  <!-- One form field: label, control, then a hint or (in its place) an error -->
  <div class="flex flex-col gap-1">
    <label class="font-medium text-surface-900 dark:text-surface-0" :for="id">{{ label }}<span v-if="optional"
        class="font-normal text-surface-500 dark:text-surface-400"> ({{ t('optional').toLowerCase() }})</span></label>
    <slot :id="id" :describedby="describedby" />
    <small v-if="error" :id="`${id}-error`" class="text-plum dark:text-rose">{{ error }}</small>
    <small v-else-if="hint" :id="`${id}-hint`" class="text-surface-500 dark:text-surface-400">{{ hint }}</small>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  label: string;
  hint?: string;
  error?: string;
  /** The control's id; one is made up when the control has none of its own. */
  for?: string;
  /** Says '(optioneel)' after the label, the same way on every form. */
  optional?: boolean;
}>();
const { t } = useI18n();

// The slot hands the id (and what the control should point aria-describedby at) to the control,
// so the label and the message belong to it without each page wiring ids by hand
const generatedId = useId();
const id = computed(() => props.for ?? generatedId);
const describedby = computed(() => props.error ? `${id.value}-error` : props.hint ? `${id.value}-hint` : undefined);
</script>
